import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import ShortletCalendarPicker from "./calendar-picker";
import { updateAgentAvailabiltyProp } from "@services/krent.service";
import { toast } from "react-toastify";
import { formatNumberWithCommas, toCalendarDateString } from "@utils/helpers";

interface AgentAvailabilityCalProps {
  availabilityModal: boolean;
  setAvailabilityModal: (value: boolean) => void;
  propertyId: string;
  normalPrice: number;
  intent?: string;
  availabilityStatus?: string;
  onRefresh?: () => void;
}

const AgentAvailabilityCal: React.FC<AgentAvailabilityCalProps> = ({
  availabilityModal,
  setAvailabilityModal,
  propertyId,
  normalPrice,
  intent,
  availabilityStatus,
  onRefresh,
}) => {
  const [status, setStatus] = useState<string>(
    intent === "sale" ? availabilityStatus || "available" : "available",
  );
  const [price, setPrice] = useState<string>("");
  const [currency, setCurrency] = useState("USD");
  // const [overwriteBooked, setOverwriteBooked] = useState<boolean>(false);
  const [selectedDuration, setSelectedDuration] = useState<
    [Date | null, Date | null]
  >([null, null]);
  const [calendarRefreshKey, setCalendarRefreshKey] = useState(0);

  const handleSave = async () => {
    if (intent !== "sale" && (!selectedDuration[0] || !selectedDuration[1]))
      return;

    const today = new Date();
    const oneYearLater = new Date();
    oneYearLater.setFullYear(today.getFullYear() + 1);

    const payload = {
      startDate:
        intent === "sale"
          ? toCalendarDateString(today)
          : selectedDuration[0]
            ? toCalendarDateString(selectedDuration[0])
            : undefined,
      endDate:
        intent === "sale"
          ? toCalendarDateString(oneYearLater)
          : selectedDuration[1]
            ? toCalendarDateString(selectedDuration[1])
            : undefined,
      price: Number(price),
      status,
      // overwriteBooked,
    };

    try {
      const response = await updateAgentAvailabiltyProp(propertyId, payload);

      toast.success((response as any).message);
      setCalendarRefreshKey((key) => key + 1);
      onRefresh?.();
      intent === "sale"
        ? setStatus(availabilityStatus || "available")
        : setStatus("available");
      setPrice("");
      setCurrency("USD");
      // setOverwriteBooked(false);
      setSelectedDuration([null, null]);

      setAvailabilityModal(false);
    } catch (error) {
      toast.error(` ${(error as any).errors[0].message}`);
    }
  };

  const isSaleIntent = intent?.trim().toLowerCase() === "sale";
  return (
    <>
      <style>{`
        .custom-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: none;
          backdrop-filter: blur(0.5px);
          -webkit-backdrop-filter: blur(8px);
          z-index: 1040;
        }
      `}</style>
      {availabilityModal && <div className="custom-backdrop" />}
      <Modal
        show={availabilityModal}
        onHide={() => setAvailabilityModal(false)}
        centered
        size="lg"
        backdrop={false}
      >
        <Modal.Header closeButton>
          <div>
            <Modal.Title>Schedule</Modal.Title>
            <p className="text-muted d-block">Set your property availability</p>
          </div>
        </Modal.Header>

        <Modal.Body>
          {intent !== "sale" && (
            <ShortletCalendarPicker
              propertyId={propertyId}
              onDurationSelect={setSelectedDuration}
              normalPrice={normalPrice}
              intent={intent}
              fetchEnabled={availabilityModal}
              refreshKey={calendarRefreshKey}
            />
          )}
          {intent === "sale" && (
            <p className="my-2">
              Current Status: <b className="capitalize">{availabilityStatus}</b>
            </p>
          )}
          {((selectedDuration[0] && selectedDuration[1]) ||
            intent === "sale") && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="available">Available</option>
                  <option value="unavailable">Unavailable</option>
                </Form.Select>
              </Form.Group>
              {!isSaleIntent && (
                <Form.Group className="mb-3">
                  <Form.Label>Price</Form.Label>
                  <div className="d-flex">
                    <Form.Select
                      value={currency}
                      onChange={(e) => setCurrency(e.target.value)}
                      className="me-2 w-auto"
                    >
                      <option value="NGN">NGN (₦)</option>
                    </Form.Select>

                    <Form.Control
                      type="text"
                      placeholder="Enter price"
                      value={formatNumberWithCommas(price)}
                      onChange={(e) =>
                        setPrice(e.target.value.replace(/,/g, ""))
                      }
                    />
                  </div>
                </Form.Group>
              )}

              {/* <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="Overwrite booked dates"
                checked={overwriteBooked}
                onChange={(e) => setOverwriteBooked(e.target.checked)}
              />
            </Form.Group> */}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setAvailabilityModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={
              intent !== "sale" &&
              (!selectedDuration[0] || !selectedDuration[1])
            }
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AgentAvailabilityCal;
